import React, { useCallback } from "react";
import { OrderFilterSetting } from "../../../../types/order/orderQuery";
import { SearchBar, SearchBarProps } from "../../../molecules/forms/SearchBar";

type SearchSectionProps = {
  filterSetting: OrderFilterSetting;
  setFilterSetting: React.Dispatch<React.SetStateAction<OrderFilterSetting>>;
} & Omit<SearchBarProps, "placeholder" | "onChange" | "value">;

export function SearchSection({
  filterSetting,
  setFilterSetting,
  ...props
}: SearchSectionProps): React.ReactElement {
  const setSearchQuery = useCallback(
    (searchQuery: string) => {
      setFilterSetting((oldState) => ({
        ...oldState,
        searchQuery,
      }));
    },
    [setFilterSetting],
  );

  return (
    <SearchBar
      placeholder="Search"
      onChange={(e) => setSearchQuery(e.target.value)}
      value={filterSetting.searchQuery}
      {...props}
    />
  );
}
